import intl from 'react-intl-universal';
import Grid from '@mui/material/Grid2';
import { Button, Typography } from '@mui/material';
import { getIssueStatus } from 'shared/constants/kenshin/issues';
import { Status } from 'components/Status/styles';
import localData from 'utils/localData';
import { USER_DATA } from 'shared/constants/users';
import { getUserPreferredTimezone } from 'utils/formatTime';
import { readableDateTimeFormat } from 'utils/dateTime';

export const getSelectedIssuesListTitle = () => {
  return (
    <Grid container spacing={2} key={0}>
      <Grid size={1}></Grid>
      <Grid size={2}>
        <Typography variant="body2" style={{ marginTop: '25px' }}>
          {intl.get('dashboard_received_history_kenshin_table_column_issue_id')}
        </Typography>
      </Grid>
      <Grid size={2}>
        <Typography variant="body2" style={{ marginTop: '25px' }}>
          {intl.get('case_list_label_column_status')}
          {/* 依頼進捗 */}
        </Typography>
      </Grid>
      <Grid size={2}>
        <Typography variant="body2" style={{ marginTop: '25px' }}>
          {intl.get('case_list_label_column_order_time')}
        </Typography>
      </Grid>
      <Grid size={2}>
        <Typography variant="body2" style={{ marginTop: '25px' }}>
          {intl.get('case_list_label_column_from')}
        </Typography>
      </Grid>
      <Grid size={2}>
        <Typography variant="body2" style={{ marginTop: '25px' }}>
          {intl.get('case_list_label_column_details')}
          {/* 詳細・その他 */}
        </Typography>
      </Grid>
    </Grid>
  );
};

export const getSelectedIssuesList = (selectedIssues, handleOpenIssueDetails) =>
  selectedIssues.map((issue, index) => {
    const lang = localData.get(USER_DATA.PREFFERED_LANGUAGE);
    const timeZone = getUserPreferredTimezone();
    return (
      <Grid container spacing={2} key={index + 1}>
        <Grid size={1}></Grid>
        <Grid size={2}>
          <Typography variant="body2" style={{ marginTop: '25px' }}>
            {issue.title}
          </Typography>
        </Grid>
        <Grid size={2}>
          {/* 依頼進捗 */}
          <Status style={{ marginTop: '25px' }} color={issue.progress}>
            {getIssueStatus(issue.progress)}
          </Status>
        </Grid>
        <Grid size={2}>
          {/* 受信時間 */}
          <Typography variant="subtitle2" style={{ marginTop: '25px' }}>
            {readableDateTimeFormat(issue.createdAt, lang, timeZone)}
          </Typography>
        </Grid>
        <Grid size={2}>
          {/* 依頼元 */}
          <Typography variant="subtitle2" style={{ marginTop: '25px' }}>
            {issue.srcOrgName}
          </Typography>
        </Grid>
        <Grid size={2}>
          <Typography
            variant="body2"
            style={{ marginTop: '25px', marginLeft: '20px' }}>
            {/* 詳細・その他 */}
            <Button
              variant="contained"
              color="primary"
              sx={{
                color: '#FFF',
              }}
              onClick={() => {
                handleOpenIssueDetails(issue.id);
              }}>
              {intl.get('case_list_button_view')}
            </Button>
          </Typography>
        </Grid>
      </Grid>
    );
  });
